module.exports = __webpack_public_path__ + "static/media/headerLogo.8a2329d7.jpeg";